import type { TrocaPageHeader } from "features/troca-titularidade/types";

export const PAGE_HEADER: TrocaPageHeader = {
  h1: "Troca de titularidade",
  h2: "Olá! Boas-vindas à você que chegou para somar energias. Confira abaixo como funciona a troca de titularidade da sua conta de gás de apartamento ou loja com medição individualizada:",
};

export const STEPPERS = ["Troca de titularidade"];
